import React, { Component, useEffect } from "react";
import Container from "@material-ui/core/Container";
import Grid from "@material-ui/core/Grid";
import Features from "../../Components/Target";
import styled from "@emotion/styled";

import Q1 from "../../img/P2-1.png";
import Q2 from "../../img/P2-2.png";
import Q3 from "../../img/P2-3.png";
const MainDiv = styled.div``;
const Span = styled.span`
  color: #ffffff;
  font-size: 40px;
  text-transform: uppercase;
  font-weight: 600;
  padding-bottom: 10px;
`;
const P = styled.p`
  color: #ffffff;
  padding-top: 30px;
`;

const S3_Portfolio = () => {
  return (
    <MainDiv className="py-5">
      <Container>
        <Grid container item className="">
          <Grid container direction="column" justify="center" xs={12}>
            <h1 className="fontweight text-center mb-5">
              <Span>
                <span style={{ borderBottom: "7px solid #B82E3C" }}>&nbsp; OUR TARGET</span> AUDIENCE
              </Span>
            </h1>
            <P className="text-center">
              we provide consultancy services to our customers who are:
            </P>
          </Grid>
          <Features title="Primarily government" cardIcon={Q1} />
          <Features title="semi government" cardIcon={Q2} />
          <Features title="Autonomous organizations" cardIcon={Q3} />
        </Grid>
      </Container>
    </MainDiv>
  );
};

export default S3_Portfolio;
